import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { Descriptions, Empty, Typography } from 'antd';
import { formatDate } from '@monorepo/client-common';
import { Flex, TextComponent } from '@monorepo/react-components';

interface Props {
  profitableDays?: Date[];
}

const AccountProfitableDays: FunctionComponent<Props> = ({
  profitableDays,
}) => {
  const { t } = useTranslation(['dashboardTemplates']);

  const items = (profitableDays || []).map((day, index) => {
    return {
      key: index,
      label: `Day ${index + 1}`,
      children: formatDate(day),
    };
  });

  if (items.length === 0) {
    return (
      <>
        <Typography.Text>
          {t('dashboardTemplates:no_profitable_days')}
        </Typography.Text>
        <Empty />
      </>
    );
  }

  return (
    <Flex vertical gap={20}>
      <TextComponent level={4} weight={600}>
        {t('dashboardTemplates:profitable_days')} ({items.length})
      </TextComponent>
      <Descriptions column={1} items={items} />
    </Flex>
  );
};

export default AccountProfitableDays;
